var _circle, _circle2, _path, _path2, _circle3, _circle4, _path3, _circle5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNonHuman = function SvgNonHuman(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 18 16"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 8,
    r: 2.4,
    stroke: "currentColor",
    strokeWidth: 1.2,
    transform: "rotate(-90 15 8)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 8,
    r: 2.4,
    stroke: "currentColor",
    strokeWidth: 1.2,
    transform: "rotate(-90 3 8)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "transparent",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M15 11.067V5.933c0-1.026 0-1.54-.218-1.932a1.93 1.93 0 0 0-.874-.801C13.48 3 12.92 3 11.8 3H6.2c-1.12 0-1.68 0-2.108.2A1.93 1.93 0 0 0 3.218 4C3 4.393 3 4.907 3 5.933v5.134c0 1.026 0 1.54.218 1.932.192.345.498.625.874.801.428.2.988.2 2.108.2h5.6c1.12 0 1.68 0 2.108-.2.376-.176.682-.456.874-.801.218-.392.218-.906.218-1.932"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M15 11.067V5.933c0-1.026 0-1.54-.218-1.932a1.93 1.93 0 0 0-.874-.801C13.48 3 12.92 3 11.8 3H6.2c-1.12 0-1.68 0-2.108.2A1.93 1.93 0 0 0 3.218 4C3 4.393 3 4.907 3 5.933v5.134c0 1.026 0 1.54.218 1.932.192.345.498.625.874.801.428.2.988.2 2.108.2h5.6c1.12 0 1.68 0 2.108-.2.376-.176.682-.456.874-.801.218-.392.218-.906.218-1.932"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 7.5,
    r: 1,
    stroke: "currentColor"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 7.5,
    r: 1,
    stroke: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M9 3V1"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 1,
    r: 1,
    fill: "currentColor"
  })));
};
export default SvgNonHuman;